import React from 'react';
import moment from 'moment';
import 'moment/locale/de';
import {
  DataTable,
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Tag,
} from '@carbon/react';

import { Page } from '@/components/Page';
import { useGetOnlineUsersQuery } from '@/redux/new_services/onlineUsers';

moment.locale('de');

// OnlineUsers — Admin-Panel das die User auflistet, die in den letzten
// 10 Minuten irgendeine authentifizierte Aktion gemacht haben. Pollt
// alle 30 Sekunden im Hintergrund (RTK Query pollingInterval). Daten
// kommen aus users.last_seen_at / users.last_action, befüllt durch die
// Auth-Middleware (siehe app/auth.go + models/user_activity.go).
const POLL_INTERVAL_MS = 30_000;
const WINDOW_MINUTES = 10;

const headers = [
  { key: 'email', header: 'E-Mail' },
  { key: 'name', header: 'Name' },
  { key: 'organisation', header: 'Organisation' },
  { key: 'last_action', header: 'Letzte Aktion' },
  { key: 'last_seen', header: 'Zuletzt aktiv' },
];

export const OnlineUsers = () => {
  const { data, isFetching, error } = useGetOnlineUsersQuery(WINDOW_MINUTES, {
    pollingInterval: POLL_INTERVAL_MS,
    refetchOnMountOrArgChange: true,
  });

  const rows = (data?.data || []).map((u) => ({
    id: String(u.id),
    email: u.email,
    name: `${u.firstname || ''} ${u.lastname || ''}`.trim() || '—',
    organisation: u.organisation || '—',
    last_action: u.last_action || '—',
    last_seen: u.last_seen_at ? moment(u.last_seen_at).fromNow() : '—',
  }));

  return (
    <Page pageTitle="Online-Benutzer" hasSideNav>
      <p style={{ marginBottom: '1rem', color: '#525252' }}>
        Aktive Sitzungen der letzten {WINDOW_MINUTES} Minuten. Wird alle
        30 Sekunden aktualisiert.
        {isFetching && (
          <Tag size="sm" type="cool-gray" style={{ marginLeft: '0.5rem' }}>
            aktualisiert …
          </Tag>
        )}
      </p>
      {error && (
        <Tag type="red">Fehler beim Laden der Liste</Tag>
      )}
      <DataTable rows={rows} headers={headers}>
        {({ rows: dtRows, headers: dtHeaders, getTableProps, getHeaderProps, getRowProps }) => (
          <TableContainer>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {dtHeaders.map((h) => (
                    <TableHeader key={h.key} {...getHeaderProps({ header: h })}>
                      {h.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {dtRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={dtHeaders.length}>
                      Keine aktiven Benutzer in den letzten {WINDOW_MINUTES} Minuten.
                    </TableCell>
                  </TableRow>
                ) : (
                  dtRows.map((row) => (
                    <TableRow key={row.id} {...getRowProps({ row })}>
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>{cell.value}</TableCell>
                      ))}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Page>
  );
};

export default OnlineUsers;
